import {
  SUGGESTIONS_ERROR,
  SUGGESTIONS_REQUESTED,
  SUGGESTIONS_SUCCESS,
} from "actions/const";
import config from "config";

function reducer(state = config.state.suggestions, action) {
  switch (action.type) {
    case SUGGESTIONS_ERROR:
      return { ...state, terms: [], loading: false };

    case SUGGESTIONS_REQUESTED:
      return { ...state, loading: true };

    case SUGGESTIONS_SUCCESS:
      const terms = action.suggestions ? action.suggestions : [];

      return { ...state, terms, loading: false };

    default:
      return state;
  }
}
export default reducer;
